<template>
    <view-card headline="기본계약사항">
        <div class="contract-terms-basic-box">{{ contractContent }}</div>
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
import contractContent from "@/assets/data/contractContent";
export default {
    components: { viewCard },
    data() {
        return { contractContent };
    },
};
</script>
<style scoped>
.contract-terms-basic-box {
    padding-right: 1em;
    max-height: 28em;
    overflow-y: auto;
    
    white-space: pre-wrap;
    text-align: justify;
}
</style>
